'use client'

import { useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Mousewheel, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { _promotions } from '@/_mock/_home'
import type { Promotion } from '@/@types'
import { ROUTES } from '@/config/routes'
import PromotionCard, { PromotionCardSkeleton } from '../promotions/PromotionCard'
import { HomeSection } from "./HomeSection"
import arrowRigth from "../../../public/images/icons/arrow-right.svg";
import Image from 'next/image'


type Props = {
  promotions: Promotion[]
}

export function Promotion({ promotions }: Props) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const swiperRef = useRef<any>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [isEnd, setIsEnd] = useState(false)
  const [isBeginning, setIsBeginning] = useState(true)

  return (
    <HomeSection
      title="APROVECHA NUESTRAS PROMOCIONES"
      mobileTitle="PROMOCIONES"
      viewAllLink={ROUTES.promotions.root}
      className="bg-white pb-[84px]"
      fullWidth
    >
      <div className="relative w-screen left-1/2 right-1/2 -mx-[50vw]">
        {isLoading && (
            <div className="px-4">
              <div className="block md:hidden">
                <PromotionCardSkeleton />
              </div>
              <div className="hidden md:grid xl:hidden md:grid-cols-3 gap-4">
                {Array.from({ length: 3 }).map((_, index) => (
                  <PromotionCardSkeleton key={index} />
                ))}
              </div>
              <div className="hidden xl:grid xl:grid-cols-4 gap-4">
                {Array.from({ length: 4 }).map((_, index) => (
                  <PromotionCardSkeleton key={index} />
                ))}
              </div>

            </div>
          )}

        <div className={isLoading ? 'hidden' : ''}>
          <Swiper
            modules={[Navigation, Mousewheel, Pagination, Autoplay]}
            onSlideChange={(swiper) => {
              setCurrentIndex(swiper.activeIndex);
              setIsEnd(swiper.isEnd)
              setIsBeginning(swiper.isBeginning)
            }}
            slidesPerView={1}
            autoplay={true} 
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 0, pagination: { enabled: true },  
                      autoplay: {
                        delay: 4000, // ⏱️ 4 segundos
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                      }, 
                    },
              768: { slidesPerView: 3.3, spaceBetween: 16, pagination: { enabled: false }, autoplay: false, },
              1024: { slidesPerView: promotions.length > 4 ? 4.2 : 3.8, spaceBetween: 18, pagination: { enabled: false }, autoplay: false, },
            }}
             pagination={{
              clickable: true,
              el: '.promotions-swiper-pagination',
            }}
            navigation={{
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next',
            }}
            mousewheel={{
              forceToAxis: true,
            }}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
              setIsLoading(false);
            }}
            wrapperClass={promotions.length <= 3 ? 'md:justify-center' : ''}
            className="pb-8 px-4 sm:px-6 lg:px-8"
          >
            {promotions.map((promotion) => (
              <SwiperSlide key={promotion.id} className="!h-auto flex">
                <div className="h-full w-full">
                  <PromotionCard item={{ promotions: [promotion], isHome: true }} />
                </div>
              </SwiperSlide>
            ))}
            <>
              <button
                onClick={() => swiperRef.current?.slideTo(currentIndex - 1)}
                className="hidden md:block absolute left-1 md:left-8 top-1/2 -translate-y-1/2 z-10 bg-slate-300 rounded p-3 border shadow-xl opacity-55"
              >
                <Image
                  className={`rotate-180 hover:opacity-55 ${isBeginning ? "opacity-55" : ""}`}
                  src={arrowRigth}
                  alt="prev Slide"
                  width={15}
                  height={15}
                />
              </button>

              <button
                onClick={() => swiperRef.current?.slideTo(currentIndex + 1)}
                className="hidden md:block absolute right-1 md:right-8 top-1/2 -translate-y-1/2 z-10 bg-slate-300 rounded p-3 border shadow-xl opacity-55"
             >
                <Image
                  className={`hover:opacity-55 ${isEnd ? "opacity-55" : ""}`}
                  src={arrowRigth}
                  alt="next Slide"
                  width={15}
                  height={15}
                />
              </button>

                <div className="promotions-swiper-pagination mt-5 flex justify-center md:hidden" />

            </>
          </Swiper>
        </div>
      </div>

    </HomeSection>
  )
}